import { render, staticRenderFns } from "./CompanyCardAdditionalInfos.vue?vue&type=template&id=7bc5d772&scoped=true&"
import script from "./CompanyCardAdditionalInfos.vue?vue&type=script&lang=ts&"
export * from "./CompanyCardAdditionalInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5d772",
  null
  
)

export default component.exports